import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-account-pending',
  templateUrl: './app.account-pending.component.html',
})
export class AppAccountPendingComponent {
  constructor(public authService: AuthService) {}

  retry(): void {
    this.authService.refreshUserData();
  }
}
